import * as React from 'react';
import "./Style/LoadingBar.scss";

export const LoadingBar = () => (
    <div className="progress-container">
        <span className="background-progress-bar">
            <span className="progress-bar indeterminate"></span>
        </span>
    </div>
)